import Modal from "react-modal";
import { CMCloseButton } from "../place-bid/place-bid/place-bid.styles";
import { ReactComponent as CloseIcon } from "../../icons/close.svg";
import { Title } from "../../Pages/RegisteredTrader/add-funds/add-funds.styles";
import Button, { BUTTON_TYPE_CLASSES } from "../button/button.component";
import { CMHeadingContainer, CMOffer } from "./gotoverify.styles";
export const customStyles = {
    overlay: {
        zIndex: "9999"
    },
    borderRadius: "50px",
    content: {
        top: "50%",
        left: "50%",
        right: "auto",
        bottom: "auto",
        marginRight: "-50%",
        transform: "translate(-50%, -50%)",
        width: "80%",
        maxWidth: "500px",
        maxHeight: "85%",
        borderRadius: 30,
        "@media(max-width: 575px)": {
            maxWidth: "300px",
        },
        "@media(max-width: 479px)": {
            maxWidth: "270px ! important",
        },
    },
  };
const GoToVerify = ({goToVerify, setAddFunds, setGoToVerify, setVerificarionOpen}) => {
    const closeModal = () => {
        setGoToVerify(false);
    }
    return (
        <Modal
            isOpen={goToVerify}
            onRequestClose={closeModal}
            style={customStyles}
            contentLabel="Example Modal"
        >
            <CMCloseButton onClick={closeModal}>
                <CloseIcon width={16} height={16} />
            </CMCloseButton>
            <Title className="title">
                <h2>Verification Request</h2>
            </Title>
            <CMHeadingContainer>
                <h3>To add the requested funds, the law requires us to verify your identity. The data we collect from you is used in accordance to our <a href="/privacy-policy" target="_blank">privacy policy</a>. <br/>Do you want to continue? </h3>
            </CMHeadingContainer>
            <CMOffer>
                <Button
                    buttonType={BUTTON_TYPE_CLASSES.BaseButton}
                    color="blue"
                    onClick={() => {
                        setVerificarionOpen(true);
                        closeModal();
                    }}
                >
                    Yes
                </Button>
                <Button
                    buttonType={BUTTON_TYPE_CLASSES.OutlinedButton}
                    color="blue"
                    onClick={() => {
                        setAddFunds(true);
                        closeModal();
                    }}
                >
                    No
                </Button>
            </CMOffer>
        </Modal>
    )
}
export default GoToVerify;
